import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('brand-navigation', () => import(/* webpackMode: "lazy" */'./brand-navigation'));
